module.exports = __webpack_public_path__ + "images/a1836ed75d01c6e96ea6279ace280f3b.svg";